import { resolveConflicts } from '../../utilities/cn';

/***
 *
 *   CLASS HELPER
 *   Builds a class string from a `*.tailwind.js` token object plus a set of
 *   boolean flags, then appends the caller's `className`.
 *
 *   The result is run through resolveConflicts so that `className` actually
 *   OVERRIDES the component's own classes rather than merely sitting beside
 *   them. Without that, `<Button className='h-4' />` emitted `h-10 ... h-4` and
 *   Tailwind's own stylesheet order picked h-10 — the wrong one. This is the
 *   same last-wins model the reference gets from tailwind-merge.
 *
 **********/

export function ClassHelper(styles, props, debug){
  
  let str = '';

  if (typeof styles === 'object'){

    if (styles.base)
      str += styles.base // always apply base styles

    if (Object.keys(props).length){
      Object.keys(props).forEach(prop => {
        
        if (prop === 'className' && props[prop]){

          // always apply className and base
          str = str.trim();
          str += ` ${props[prop]}`;

        }
        else if (props[prop] && styles.hasOwnProperty(prop)){

          if (debug)
            console.log('styles', prop, props[prop], styles[prop]);

          str = str.trim();
          str += ` ${styles[prop]}`;

        }
      });
    }
  }

  if (debug)
    console.log('final.class', str.trim());

  return resolveConflicts(str);

}